export enum StoreRelationTypeEnum {
  SERVICE_CAR = "SERVICE_CAR",
  POS_DEVICE = "POS_DEVICE",
  CAMPAIGN = "CAMPAIGN",
  DEVICE = "DEVICE",
  COMPONENT = "COMPONENT",
  EXCLUDE_COMPONENT = "EXCLUDE_COMPONENT",
  EXPENSE_TYPE = "EXPENSE_TYPE",
  ORDER_ITEM_TP = "ORDER_ITEM_TP",
  PAYMENT_TYPE = "PAYMENT_TYPE",
  PAYMENT_TYPE_CASH_REGISTER = "PAYMENT_TYPE_CASH_REGISTER",

  ALLOWED_STORE_CUSTOMER = "CUSTOMER",
  ALLOWED_STORE_ORDER = "ORDER",
  ALLOWED_STORE_PAYMENT = "PAYMENT",
  ALLOWED_STORE_REPORT = "ALLOWED_STORE_REPORT",
  ALLOWED_MANAGE_STORE = "ALLOWED_MANAGE_STORE",

}
